<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <okmenu-logo />
      <h2 class="brand-text text-primary ml-1">
        WiSHOP
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          ⌛ Coming Soon ⌛
        </h2>
        <p class="mb-2">
          Dashboard Under Construction 🚧🏗
        </p>

        <b-link
          v-if="$route.query.from === 'tablet'"
          class="btn btn-primary btn-lg"
          href="/close-now"
        >
          Close
        </b-link>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink } from 'bootstrap-vue'
import OkmenuLogo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    OkmenuLogo,
    BLink,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
